import axios, { AxiosResponse } from "axios";
import config from "../../config";
import {
  MessageType,
  MessageTypeEnum,
  setMessage,
} from "../../redux/reducers/messageReducer";
import { Dispatch } from "redux";
import Cookies from "js-cookie";

const client = axios.create({
  baseURL: `${config.api.BASE_URL}`,
});

const dispatchError = (dispatch: Dispatch, error: any) => {
  const message: MessageType = {
    type: MessageTypeEnum.Error,
    display: "bar",
    title: "API Error",
    description: error.response?.data?.message || "An unknown error occurred.",
  };
  dispatch(setMessage(message));
};

export const apiGet = async <T>(
  dispatch: Dispatch,
  url: string,
): Promise<T> => {
  try {
    const token = Cookies.get("access_token");
    if (token) {
      client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const response: AxiosResponse<T> = await client.get<T>(url);

    return response.data;
  } catch (error: any) {
    dispatchError(dispatch, error);
    return error.data;
  }
};

export const apiPost = async <T, U>(
  dispatch: Dispatch,
  url: string,
  data?: U,
  contentType?: string,
): Promise<T> => {
  try {
    const token = Cookies.get("access_token");
    if (token) {
      client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    if (contentType) {
      client.defaults.headers.common["Content-Type"] = contentType;
    }
    const response: AxiosResponse<T> = await client.post<T>(url, data);
    return response.data;
  } catch (error: any) {
    dispatchError(dispatch, error);
    return error.data;
  }
};

export const apiDelete = async <T, U>(
  dispatch: Dispatch,
  url: string,
  data?: U,
): Promise<T> => {
  try {
    const token = Cookies.get("access_token");
    if (token) {
      client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const response: AxiosResponse<T> = await client.delete<T>(url, { data });
    return response.data;
  } catch (error: any) {
    dispatchError(dispatch, error);
    return error.data;
  }
};

export const apiPut = async <T, U>(
  dispatch: Dispatch,
  url: string,
  data?: U,
): Promise<T> => {
  try {
    const token = Cookies.get("access_token");
    if (token) {
      client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const response: AxiosResponse<T> = await client.put<T>(url, data);
    return response.data;
  } catch (error: any) {
    dispatchError(dispatch, error);
    return error.data;
  }
};
